import { Text, View } from "@react-pdf/renderer";
import React from "react";

const tableRowStyle: any = {
  flexDirection: "row",
};

const tableColHeaderStyle: any = {
  borderStyle: "solid",
  borderColor: "#000",
  borderBottomColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
};

const tableCellHeaderStyle: any = {
  textAlign: "center",
  margin: 4,
  marginTop: 2,
  marginBottom: 2,
  fontSize: "6px",
  fontWeight: "bold",
};

export const TableHeader = () => {
  return (
    <View style={tableRowStyle} fixed>
      <View style={{ ...tableColHeaderStyle, borderLeftWidth: 1, width: "4%" }}>
        <Text style={tableCellHeaderStyle}>#</Text>
      </View>

      <View style={{ ...tableColHeaderStyle, width: "7%" }}>
        <Text style={{ ...tableCellHeaderStyle }}>QTY</Text>
      </View>

      <View style={{ ...tableColHeaderStyle, flex: 1 }}>
        <Text style={tableCellHeaderStyle}>CODE</Text>
      </View>

      <View style={{ ...tableColHeaderStyle, flex: 6 }}>
        <Text style={tableCellHeaderStyle}>DESCRIPTION</Text>
      </View>

      <View style={{ ...tableColHeaderStyle, flex: 1 }}>
        <Text style={tableCellHeaderStyle}>UNIT PRICE</Text>
      </View>

      <View style={{ ...tableColHeaderStyle, flex: 2, paddingRight: 15 }}>
        <Text style={tableCellHeaderStyle}>AMOUNT</Text>
      </View>
    </View>
  );
};
